import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchSuggestion } from '@pylot-data/hooks/search/use-search-suggestion'
import s from './SearchAutocomplete.module.scss'
import ProductItemTiny from './ProductItemTiny'
import CategoryList from './CategoryList'

import Link from 'next/link'
import { LoadingDots } from '@corratech/pylot-ui'
type autoCompleteType = {
    searchTerm: string
    searchPageURL: string
}
const SearchAutocomplete: FC<autoCompleteType> = ({
    searchTerm,
    searchPageURL
}) => {
    const { t } = useTranslation()
    const {
        products,
        aggregations,
        isValidating
    } = useSearchSuggestion(searchTerm, { revalidateOnFocus: false })

    if (isValidating) {
        return (
            <div className={s['search-container']}>
                <LoadingDots />
            </div>
        )
    }

    if (products?.items && products.items.length > 0) {
        return (
            <div className={s.autocomplete}>
                <div className={s['autocomplete-list']}>
                    <Link href={`${searchPageURL}?q=${searchTerm}`}>
                        <h3 className={s['autocomplete-heading']}>
                            {t('{{ count }} Products', {
                                count: Number(products.total_count)
                            })}
                        </h3>
                    </Link>
                    {products.items.map((product, index) => {
                        return <ProductItemTiny product={product} key={index} />
                    })}
                </div>
                <div className={s['autocomplete-categories']}>
                    <CategoryList
                        searchTerm={searchTerm}
                        aggregations={aggregations}
                    />
                </div>
            </div>
        )
    } else {
        return (
            <div className={s['search-container']}>
                {t('No Suggestions Found')}
            </div>
        )
    }
}

export default SearchAutocomplete
